module.exports = __webpack_public_path__ + "img/p2.99777984.png";